import { useCallback } from "react";
import analytics from "@services/analytics";
import {
  CMS_ENTITY_TYPE,
  DISCOVERY_FLOW_EVENTS,
  ORDER_FLOW_EVENTS,
  OTHER_EVENTS,
  SHARING_EVENTS,
} from "../constants/analyticsEventsCT";

const useCMSEvents = (screenName) => {
  const trackEvent = (type, data) => {
    switch (type) {
      case DISCOVERY_FLOW_EVENTS.PRODUCT_SEARCH_ICON:
        analytics.trackEvent(DISCOVERY_FLOW_EVENTS.PRODUCT_SEARCH_ICON, {
          previous_screen: screenName,
        });
        break;
      case CMS_ENTITY_TYPE.PRODUCT_LIST:
        // eslint-disable-next-line no-case-declarations
        const { cl_title, cx_title, cms_item_id } = data;
        analytics.trackEvent(DISCOVERY_FLOW_EVENTS.PRODUCT_LIST_VIEWED, {
          cl_title,
          cx_title,
          cms_item_id,
          previous_screen: screenName,
        });
        break;
      case ORDER_FLOW_EVENTS.PRODUCT_CLICKED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_CLICKED, {
          previous_screen: screenName,
          ...data,
        });
        break;
      case OTHER_EVENTS.MESSAGE_LEADER:
        analytics.trackEvent(OTHER_EVENTS.MESSAGE_LEADER, {
          screen_name: screenName,
          ...data,
        });
        break;
      case OTHER_EVENTS.BANNER_CLICKED:
        analytics.trackEvent(OTHER_EVENTS.BANNER_CLICKED, {
          banner_type: data.sub_type || "",
          cms_item_id: data.cms_item_id || "",
          cms_title: data.cms_title || "",
          screen_name: screenName,
        });
        break;
      case ORDER_FLOW_EVENTS.PRODUCT_BUNDLED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_BUNDLED, {
          previous_screen: screenName,
          ...data,
        });
        break;
      case ORDER_FLOW_EVENTS.PRODUCT_REMOVED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_REMOVED, {
          ...data,
        });
        break;
      case CMS_ENTITY_TYPE.NXM_BANNER:
        analytics.trackEvent(CMS_ENTITY_TYPE.NXM_BANNER, {
          ...data,
        });
        break;
      case CMS_ENTITY_TYPE.WA_MSG_BANNER:
        analytics.trackEvent(CMS_ENTITY_TYPE.WA_MSG_BANNER, {
          screen_name: screenName,
          ...data,
        });
        break;
      case ORDER_FLOW_EVENTS.PRODUCT_ADDED:
        analytics.trackEvent(ORDER_FLOW_EVENTS.PRODUCT_ADDED, {
          ...data,
        });
        break;
      case SHARING_EVENTS.GB_SHARE:
        analytics.trackEvent(SHARING_EVENTS.GB_SHARE, {
          screen_name: screenName,
          gb_id: data.gb_id,
        });
        break;
      case SHARING_EVENTS.PRODUCT_SHARE:
        analytics.trackEvent(SHARING_EVENTS.PRODUCT_SHARE, {
          screen_name: screenName,
          ...data,
        });
        break;
    }
  };
  return trackEvent;
};

export default useCMSEvents;
